import { render } from "./PartnerLoginPage.vue?vue&type=template&id=6d0dc1f2&scoped=true"
import script from "./PartnerLoginPage.vue?vue&type=script&lang=js"
export * from "./PartnerLoginPage.vue?vue&type=script&lang=js"

import "./PartnerLoginPage.vue?vue&type=style&index=0&id=6d0dc1f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0dc1f2"]])

export default __exports__